/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckIn/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AssignConnection from './AssignConnection/index'
import Children from 'Simple/Children'
import Confirmation from './Confirmation/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CheckIn({
  children,
  viewPath = "/DesignSystem/CheckIn",
  onSubmit
  
}) {
let checkInSubmitData = fromData.useDataSubmit({ viewPath,
context: 'check_in',
})
let checkInDisabledValueData = fromData.useDataValue({ viewPath,
context: 'check_in',
path: 'disabled',
})
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
 data="check_in"
 onClick={checkInSubmitData}
 data="check_in.disabled"
 disabled={checkInDisabledValueData}
>
{children}
</Children>
<AssignConnection
  viewPath={`${viewPath}/AssignConnection`}
/>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
</React.Fragment>)
}